module.exports = __webpack_public_path__ + "img/domestic-transport.c8c9d37b.png";